import { useTheme } from '@emotion/react';
import { Box, Stack } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import { useLocation, useSearchParams } from 'react-router-dom';
import useZoomAwareSize from '../hooks/use.zoomAwareSize';
import GlobalLoader from '../components/backdrop';
import Alert from '../components/dialog/Alert';
import FooterComponent from '../components/footer';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Toaster from '../components/toaster/toaster';
import AccessDenied from '../pages/accessDenied';
import { UrlRestrictionsArray } from '../utils/common';
import { getParamMasterList } from './action';
import useDeviceType from '../hooks/useDeviceType';
import SidebarMobile from '../components/sidebarMobile';
import WishlistSidebar from '../pages/dashboard/WishlistSidebar';
import { updateCommonData } from '../redux/commonSlice';
const Layout = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const deviceType = useDeviceType();
  const toolbarHeight = theme.spacing(0);
  const {isScreenZoomed} = useSelector(state=>state.commonSlice);
  const states = useSelector(state => state.app);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const wishlistId = searchParams.get('wishlistId');
  const isZoomed = useZoomAwareSize();

  useEffect(() => {
    dispatch(updateCommonData({isScreenZoomed:isZoomed}))
  }, [dispatch, isZoomed])

  useEffect(() => {
    dispatch(getParamMasterList());
  }, []);

  const url = location?.pathname?.split('/').filter(v => v !== '')[0];
  const permessions = UrlRestrictionsArray.find(v => v.urlKey === url);

  if (states.permissions?.[permessions?.pKey]?.view == 0) {
    return <AccessDenied />;
  }

  const discoverBackgroundPaths = [
    '/discover-influencers',
    '/discover-influencers/listing',
    '/discover',
  ];

  const discoverInfluListingPaths = [
    '/discover-influencers/listing',
    '/wallet',
    '/company-brands',
    '/my-campaigns',
    '/subscription/history',
    '/subscription/active',
    '/list',
    '/company/users',
    '/notification/history',
    '/notification/group',
    '/audit-trails',
    '/kyc',
    '/subscriptions',
    '/roles',
    '/adminUsers',
    '/campaign-management',
    '/companies',
    '/userManagement',
    '/',
  ];

  const isDiscoverPage = discoverBackgroundPaths.includes(location.pathname);
  const isInfluListingPage = discoverInfluListingPaths.some(
    path => location.pathname.startsWith(path) || location.pathname === path
  );

  const isNoPaddingPage = [
    '/discover-influencers/listing',
    '/list/listing','/list',
    '/',
  ].includes(location.pathname) || location.pathname.startsWith('/userManagement/details/');
  return (
    <Stack direction="row" sx={{ height: '100vh', overflow: 'hidden' }}>
      <GlobalLoader />
      <Toaster />
      <Box sx={{ width: '100%', }}>
        <Header />
        {deviceType === 'desktop' ? <Sidebar /> : <SidebarMobile />}

        <Box
          className={`bodyArea ${isDiscoverPage ? 'discover-background' : 'bg-f0f0f0'} ${
            isInfluListingPage ? 'discover-influ-listing' : ''
          }`}
          ml={states.sidebarWidth}
          px={3}
          py={isNoPaddingPage ? 0 : 2}
          position="relative"
          minHeight={`calc(100vh - ${toolbarHeight})`}
          sx={{
            paddingTop: isNoPaddingPage ? '64px' : '88px',
            transition: `all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}`,
            overflowY: 'auto',
            overflowX: 'hidden',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div className="innerBody">
            <div
              className="containerFluid"
              style={{
                padding: isNoPaddingPage
                  ? '0px'
                  : '0px 0px 30px 0px',
              }}
            >
              <Outlet />
            </div>
          </div>
          <FooterComponent />
        </Box>
        <Alert />
      </Box>

    </Stack>
  );
};

export default Layout;
